import React, { FunctionComponent } from 'react'
import { StyleProp, ViewStyle } from 'react-native'

import { BadgeShape, BadgeVariant } from '../../badge/constants'
import { TextBadge } from '../icons/TextBadge'

export type ActivityBadgeProps = {
  text: string | number | React.ReactNode | null
  backgroundColor?: string
  customTextNode?: React.ReactNode
  badgeStyle?: StyleProp<ViewStyle>
  variant?: BadgeVariant
  shape?: BadgeShape
  preserveCase?: boolean
  bold?: boolean
  testID?: string
}
/**
 * Badge used on the activities page - uses the standardized TextBadge system
 */
export const ActivityBadge: FunctionComponent<ActivityBadgeProps> = ({
  text,
  customTextNode,
  backgroundColor,
  badgeStyle,
  variant = BadgeVariant.NEUTRAL,
  shape = BadgeShape.ROUND,
  preserveCase = false,
  bold = false,
  testID = 'ActivityBadge',
}) => {
  return (
    <TextBadge
      text={customTextNode ? customTextNode : (text as any)}
      variant={variant}
      shape={shape}
      preserveCase={preserveCase}
      bold={bold}
      backgroundColor={backgroundColor}
      testID={testID}
      style={badgeStyle}
    />
  )
}
